import { micrositesMetadataListForTests } from './constants'
import { CMS_MICROSITE_MESSAGE, CMS_MICROSITE_MESSAGE_KEY } from './messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from './types'
import { API_REQUEST_HEADERS } from '../common/constants/requestHeaderConstants'
import { getGoodnessBaseUrl } from '../common/utils/commonUtils'
import { CustomPathwayOption } from '../pathways/constants'

export const getMicrositeUrl = (
  url: string,
  isLibraryEventsDisabled: boolean,
  displayLanguage?: string,
  theme?: string,
) => {
  const micrositeUrl = `${getGoodnessBaseUrl(displayLanguage)}${url}`
  const params = new URLSearchParams()
  if (isLibraryEventsDisabled) {
    params.set('x-disabled-work-hub-events', 'true')
  }
  if (theme) {
    params.set(API_REQUEST_HEADERS.X_LYRA_THEME, theme)
  }
  const queryString = params.toString()
  return queryString ? `${micrositeUrl}?${queryString}` : micrositeUrl
}

export const getMicrositePathwayKey = (
  micrositeId: CMS_MICROSITE_ID,
  messageKey: CMS_MICROSITE_MESSAGE,
): CustomPathwayOption => {
  return `CustomPathway${micrositeId}${messageKey.charAt(0).toUpperCase()}${messageKey.slice(1)}`
}

export const getWebinarLink = (micrositeMetadata: CMSMicrositeMetadata) => {
  return micrositeMetadata.postMessageEvents.find((item) => item.key === CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR)
    ?.params?.webinarLink
}

/** For tests, when it doesn't matter which microsite we use, return the first one in our list */
export const getMicrositeFromList = () => {
  if (micrositesMetadataListForTests.length < 1) {
    return null
  }
  return micrositesMetadataListForTests[0]
}
